import styled, { css } from 'styled-components';
import { breakpoints, cssfonts, cssprops, pxToCssFont, pxToRem } from '@vfit/shared/themes';
import { IInstallationAddressForStyled } from './installationAddress.models';

const hasTitleCss = css`
  @media (min-width: ${breakpoints.desktop}) {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Section = styled.section<IInstallationAddressForStyled>`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(32)};
  ${({ hasTitle }) => (hasTitle ? hasTitleCss : '')};
  ${cssprops.styled}
`;

export const Title = styled.div`
  ${cssfonts.light}
  ${pxToCssFont(28, 36)}
  text-align: center;

  b {
    ${cssfonts.exbold}
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 48)}
    max-width: ${pxToRem(514)};
    text-align: left;
  }
`;

